import { getEnvUrl,getToken,axiosInstance } from "../../utils/Api";
 
    export const createSystemUser = async (insertData) =>{ 
    try {
        const response = await axiosInstance.post("/admin/systemUserCreate",insertData,{
            headers: {
                'Content-Type': 'application/json',
                Authorization: `Bearer ${getToken()}`,
            }
        });
        return response.data;
      } catch (error) {
        throw error;
      } 
  } 
    export const updateSystemUser = async (insertData) =>{ 
    try {
        const response = await axiosInstance.put("/admin/systemuserupdate",insertData,{
            headers: {
                'Content-Type': 'application/json',
                Authorization: `Bearer ${getToken()}`,
            }
        });
        return response.data;
      } catch (error) {
        throw error;
      } 
  } 

export const getSystemUserByID = async (UserId) => {
  try {
    const response = await axiosInstance.get(`/admin/getSystemUser`, {
      params: { id: UserId }, 
      headers: {
        Authorization: `Bearer ${getToken()}`,
      },
    });
    return response.data;
  } catch (error) {
    console.error('Error in get User By ID:', error);
    return false;
  }
};

export const deleteSystemUserByID = async (deleteUserID) => {
  try {
    const response = await axiosInstance.put(
      `/admin/systemUserActiveOrDeactivate`,
      {
        user_id: deleteUserID,
        active: false
      },
      {
        headers: {
          Authorization: `Bearer ${getToken()}`,
        },
      }
    );
    return response.data;
  } catch (error) {
    console.error('Error in delete User:', error);
    return false;
  }
};

export const getAllRoles = async () => {
  try {
    const response = await axiosInstance.get(`/admin/roles/getAllRoles`, {
      headers: {
        Authorization: `Bearer ${getToken()}`,
      },
    });
    return response.data;
  } catch (error) {
    console.error('Error in get roles:', error);
    return false;
  }
};